import React, { FC } from 'react';

import { Layout, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';
import { selectIsCounterpartySpace } from '@app/store/currentSessionReducer';
import { HeaderTitle } from '@components/HeaderTitle';

import { CreateWarehouseButton } from './components/CreateWarehouseButton';
import { CustomerWarehouses } from './components/CustomerWarehouses';
import { ProviderWarehouses } from './components/ProviderWarehouses';

export const List: FC = () => {
  const warehousesT = useTranslation(NSKeys.warehouses);
  const isCounterparty = useLocalSelector(selectIsCounterpartySpace);
  const canCreate = useLocalSelector(
    (state) => !!state.currentSession.warehousesContext?.scope?.$permissions?.create_warehouses
  );

  return (
    <>
      <Layout.Header>
        <Row justify="space-between" align="middle">
          <HeaderTitle title={warehousesT.t('title')} />
          {canCreate && <CreateWarehouseButton />}
        </Row>
      </Layout.Header>

      {isCounterparty ? <ProviderWarehouses /> : <CustomerWarehouses />}
    </>
  );
};
